<app-dialog
  #dialog
  [key]="'generate-client-contract'"
  [action]="'generate-client-contract'"
  [headerTheme]="'simple'"
  [title]="'Gerar contrato'"
  [appendTo]="'body'"
  [maxWidth]="'820px'">
  <div class="p-4 generate-client-contract">
    <p class="generate-client-contract__intro">
      O contrato de <strong>{{ companyName() }}</strong> sai do
      <strong>modelo vigente do tipo escolhido</strong>, com os dados do cadastro da empresa e os
      valores abaixo no lugar das variáveis. O texto das cláusulas é fixo; depois de gerado, você
      muda os valores no editor. O tipo não muda depois de gerado.
    </p>

    <div class="generate-client-contract__row">
      <app-select label="Tipo de contrato" [options]="typeOptions" [formControl]="typeControl" />
      <app-input
        id="generate-client-contract-title"
        label="Título (opcional)"
        placeholder="Vazio: o título padrão do tipo"
        [maxLength]="300"
        [formControl]="titleControl" />
    </div>

    <app-client-contract-automatic-data
      [data]="automatic()"
      [missing]="missingAutomatic()"
      [loading]="automaticLoading()"
      fixLabel="Fechar e corrigir o cadastro"
      (fix)="closeToFixRegistration()" />

    <h4 class="generate-client-contract__subtitle">Valores do contrato</h4>
    @if (catalogLoading()) {
      <app-loading />
    } @else {
      <app-client-contract-fields-form
        [form]="fieldsForm"
        [companyId]="companyId()"
        layout="double" />
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="saving()"
        [loadingText]="'Gerando...'"
        [label]="'Gerar contrato'"
        icon="pi pi-file-edit"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
